module.exports = __webpack_public_path__ + "static/media/zulick86.0fa6b057.png";